import { render, staticRenderFns } from "./viewfactura.vue?vue&type=template&id=223355db&scoped=true"
import script from "./viewfactura.vue?vue&type=script&lang=js"
export * from "./viewfactura.vue?vue&type=script&lang=js"
import style0 from "./viewfactura.vue?vue&type=style&index=0&id=223355db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223355db",
  null
  
)

export default component.exports